import axios from '../utils/axios';

//未读消息
export const notifiy = async () => {
    const res = await axios.get(`/api/opencms/notification/notRead`);
    return res;
};

//搜索
export const search = async (keyword) => {
    const res = await axios.get(`/api/opencms/search?current=1&size=10&keyword=${keyword}`);
    return res;
};

//登出
export const logout = async () => {
    const res = await axios.get(`/api/opencms/logout`);
    return res;
};
//获取邮箱验证码
export const sendEmailCode = async (email) => {
    const res = await axios.get(`/api/opencms/user/sendEmailCode?email=${email}`);
    return res;
};

export const updatePassword = async (params) => {
    const res = await axios.post(`/api/opencms/user/updatePassword`, params);
    return res;
};
//用户信息
export const userInfo = async (username) => {
    const res = await axios.get(`/api/opencms/user/${username}`);
    return res;
};
//文章
export const articles = async (params) => {
    const { username, current, size } = params;
    const res = await axios.get(`/api/opencms/user/${username}/articles?current=${current}&size=${size}`);
    return res;
};
//评论列表
export const comments = async (params) => {
    const { username, current, size } = params;
    const res = await axios.get(`/api/opencms/user/${username}/comments?current=${current}&size=${size}`);
    return res;
};
//收藏的话题
export const collects = async (params) => {
    const { username, current, size } = params;
    const res = await axios.get(`/api/opencms/user/${username}/collects?current=${current}&size=${size}`);
    return res;
};
//问答
export const faqs = async (params) => {
    const { username, current, size } = params;
    const res = await axios.get(`/api/opencms/user/${username}/faqs?current=${current}&size=${size}`);
    return res;
};
//话题
export const topics = async (params) => {
    const { username, current, size } = params;
    const res = await axios.get(`/api/opencms/user/${username}/topics?current=${current}&size=${size}`);
    return res;
};
//评论
export const create = async (params) => {
    const res = await axios.post(`/api/opencms/comment/create`, params);
    return res;
};

export const vote = async (id) => {
    const res = await axios.get(`/api/opencms/comment/vote/${id}`);
    return res;
};

export const topicVote = async (id) => {
    const res = await axios.get(`/api/opencms/topic/${id}/vote`);
    return res;
};
//上传
export const upload = async (params) => {
    const res = await axios({
        url: '/api/opencms/upload',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: params
    });
    return res;
};

//删除话题

export const deleteTopic = async (id) => {
    const res = await axios.get(`/api/opencms/topic/delete/${id}`);
    return res;
};

//删除评论

export const deleteComment = async (id) => {
    const res = await axios.get(`/api/opencms/comment/delete/${id}`);
    return res;
};

//修改评论
export const updateComment = async (id, params) => {
    const res = await axios.post(`/api/opencms/comment/update/${id}`, params);
    return res;
};
